import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 3l-5 5 5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back to Home
        </Link>
        
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="last-updated">Last updated: November 26, 2025</p>
        
        <div className="legal-content">
          <p>
            Welcome to Discoverly, operated by Flux Software, Inc. ("Discoverly," "we," "our," or "us").
          </p>
          <p>
            This Privacy Policy explains how we collect, use, and share your information when you use our mobile app, website, and related services (the "Service").
          </p>
          <p>
            By using Discoverly, you agree to the practices described here. If you do not agree, please do not use the Service.
          </p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              We collect the following types of information:
            </p>

            <h3>1.1 Information You Provide</h3>
            <ul>
              <li><strong>Account information:</strong> such as your email address and username.</li>
              <li><strong>Profile content:</strong> including photos, posts, polls, or other content you upload.</li>
              <li><strong>Communications:</strong> messages you send us or responses to surveys or feedback forms.</li>
            </ul>

            <h3>1.2 Information We Collect Automatically</h3>
            <ul>
              <li><strong>Device and usage data:</strong> IP address, device type, operating system, and app usage statistics.</li>
              <li><strong>Cookies and similar technologies:</strong> used to understand engagement, personalize recommendations, and improve performance.</li>
              <li><strong>Click activity:</strong> when you interact with affiliate links or merchants through the app.</li>
            </ul>

            <h3>1.3 Information from Third Parties</h3>
            <ul>
              <li><strong>Affiliate partners:</strong> we may receive limited data (like link clicks or conversion information) from affiliate networks and merchants to track commissions.</li>
              <li><strong>Analytics providers:</strong> such as Firebase, Amplitude, or similar tools, which help us understand app performance.</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve the Discoverly experience;</li>
              <li>Personalize your feed, polls, and recommendations;</li>
              <li>Communicate with you about updates or policy changes;</li>
              <li>Monitor and prevent fraud or misuse; and</li>
              <li>Measure engagement and affiliate performance.</li>
            </ul>
            <p>
              We may also use aggregated or de-identified data for analytics and business insights.
            </p>
          </section>

          <section>
            <h2>3. How We Share Information</h2>
            <p>
              We do not sell your personal information.
            </p>
            <p>We may share limited information as follows:</p>
            <ul>
              <li>With service providers who help us operate the app (hosting, analytics, email delivery, etc.);</li>
              <li>With affiliate networks and merchants to track referral activity and commissions;</li>
              <li>For legal reasons, such as to comply with law enforcement requests or protect our rights;</li>
              <li>In case of a business transfer, such as a merger or acquisition of Flux Software, Inc.</li>
            </ul>
          </section>

          <section>
            <h2>4. User Content Visibility</h2>
            <p>
              Anything you post publicly (e.g., photos, polls) may be visible to other users within Discoverly and shared outside the platform.
            </p>
            <p>
              Please avoid posting personal or sensitive information you do not wish to make public.
            </p>
          </section>

          <section>
            <h2>5. Your Choices</h2>
            <ul>
              <li><strong>Access and deletion:</strong> You can access, update, or delete your account at any time by contacting us.</li>
              <li><strong>Marketing communications:</strong> You can unsubscribe from promotional emails using the link in the message.</li>
              <li><strong>Cookies:</strong> You can manage or disable cookies through your browser or device settings.</li>
              <li><strong>Data rights (EEA/California):</strong> Depending on your region, you may have the right to request access, correction, deletion, or limitation of processing of your personal data.</li>
            </ul>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We keep your data only as long as necessary to provide the Service or comply with legal obligations.
            </p>
            <p>
              When your account is deleted, associated personal information is removed or anonymized within a reasonable timeframe.
            </p>
          </section>

          <section>
            <h2>7. Security</h2>
            <p>
              We use reasonable technical and organizational measures to protect your information.
            </p>
            <p>
              However, no system is completely secure, and we cannot guarantee absolute security of your data.
            </p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Discoverly is intended for users 13 years and older.
            </p>
            <p>
              We do not knowingly collect personal information from children under 13.
            </p>
            <p>
              If we learn that we have collected such information, we will delete it promptly.
            </p>
          </section>

          <section>
            <h2>9. International Users</h2>
            <p>
              Discoverly is operated from the United States but is available worldwide except where prohibited by law.
            </p>
            <p>
              By using our Service, you consent to your data being processed in the U.S. and other countries where we or our partners operate.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time.
            </p>
            <p>
              If we make material changes, we'll notify you by email or through the app.
            </p>
            <p>
              Your continued use of Discoverly after updates means you accept the revised policy.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              Flux Software, Inc.<br/>
              Email: <a href="mailto:gevorg@joindiscoverly.com">gevorg@joindiscoverly.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

